import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighMaps from "highcharts/modules/map";
import mapDataWorld from "@highcharts/map-collection/custom/world.geo.json";
import data from "src/assets/data.json";

HighMaps(Highcharts);

const options = {
  title: {
    text: "Fixed tooltip with HTML",
  },
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  legend: {
    title: {
      text: "Population density per km²",
      style: {
        color:
          // theme
          (Highcharts.defaultOptions &&
            Highcharts.defaultOptions.legend &&
            Highcharts.defaultOptions.legend.title &&
            Highcharts.defaultOptions.legend.title.style &&
            Highcharts.defaultOptions.legend.title.style.color) ||
          "black",
      },
    },
  },
  mapNavigation: {
    enabled: true,
    buttonOptions: {
      verticalAlign: "bottom",
    },
  },
  tooltip: {
    // backgroundColor: "none",
    // borderWidth: 0,
    // shadow: false,
    // useHTML: true,
    // padding: 0,
    // pointFormat:
    //   '<span class="f32"><span class="flag {point.properties.hc-key}">' +
    //   "</span></span> {point.name}<br>" +
    //   '<span style="font-size:30px">{point.value}/km²</span>',
    // positioner: function () {
    //   return { x: 0, y: 250 };
    // },
  },
  colorAxis: {
    min: 1,
    max: 1000,
    type: "logarithmic",
    minColor: "#EEEEFF",
    maxColor: "#45a5f5",
    stops: [
      [0, "#EFEFFF"],
      [0.67, "#45a5f5"],
      [1, "#2F5EC4"],
    ],
  },
  series: [
    {
      mapData: mapDataWorld,
      data: [],
      joinBy: ["iso-a3", "code3"],
      name: "Population density",
      states: {
        hover: {
          color: "#a4edba",
        },
      },
    },
  ],
};

function Result() {
  const chartRef = useRef(null);

  useEffect(() => {
    let d = data.map((p) => {
      p.value = p.value < 1 ? 1 : p.value;

      return p;
    });

    chartRef.current.chart.series[0].update({
      data: [...d],
    });
  }, []);

  return (
    <div className="flex flex-col h-full flex-grow">
      <div className="flex justify-between items-center">
        <div className="flex-shrink-0 flex items-center">
          <span className="font-light text-lg text-gray-700 tracking-wide">
            Details
          </span>
        </div>
      </div>

      <div
        className={`flex flex-col mt-1 bg-white border border-gray-200 rounded p-5 pt-7`}
      >
        <div className="flex justify-between items-center mb-12 px-2">
          <h5 className="text-gray-750 mb-0">Traffic</h5>
        </div>

        <div className="flex justify-center">
          <HighchartsReact
            ref={chartRef}
            constructorType={"mapChart"}
            highcharts={Highcharts}
            options={options}
          />
        </div>
      </div>
    </div>
  );
}

export default Result;
